// extracted by mini-css-extract-plugin
export default {"link":"mGoGm2","image":"lDHlrQ","root":"dWLwCn"};